"use client";

import S from "./index.module.scss";
import { useState } from "react";
import CustomIcon from "@/components/ui/custom-icon";
import { useTranslations } from "next-intl";
import Link from "next/link";
import { useMedia } from "@/hooks/system/useMedia";
import Sidebar from "../sidebar";

const Menu = () => {
  const { isDesktop, isClient } = useMedia();
  const [open, setOpen] = useState(false);

  const t = useTranslations("header");

  return (
    <>
      {open && <Sidebar />}

      <div className={S.navWrapper}>
        <div className={S.nav}>
          <Link href="/">
            <CustomIcon className={S.logo} fileName="icon-logo" />
          </Link>
          <div className={S.buttonWrapper}>
            <Link href="/about" className={S.menuNav}>
              {t("about")}
            </Link>
            <Link href="/production" className={S.menuNav}>
              {t("production")}
            </Link>
            <Link href="/vacancy" className={S.menuNav}>
              {t("vacancies")}
            </Link>
            <Link href="/academy" className={S.menuNav}>
              {t("academy")}
            </Link>
            <Link href="/culture" className={S.menuNav}>
              {t("corporateCulture")}
            </Link>
          </div>
          {!isDesktop && isClient && (
            <button onClick={() => setOpen(value => !value)} className={S.menuButton}>
              <CustomIcon fileName="icon-menu" />
            </button>
          )}
        </div>
      </div>
    </>
  );
};

export default Menu;
